const baseUrl = (process.env.BASE_URL || '/').replace(/\/$/, '')

export const APP_VERSION = process.env.VUE_APP_BUILD_VERSION || 'dev'
export const APP_COMMIT = process.env.VUE_APP_BUILD_COMMIT || ''
export const APP_BUILD_TIME = process.env.VUE_APP_BUILD_TIME || ''
export const APP_RELEASE_CHANNEL = process.env.VUE_APP_RELEASE_CHANNEL || process.env.NODE_ENV || 'local'
export const API_COMPAT_VERSION = process.env.VUE_APP_API_COMPAT_VERSION || 'v1'
// 该文件由构建流程生成，入口页和路由回退必须禁缓存，确保旧页面能发现新版本。
export const VERSION_ENDPOINT = `${baseUrl}/version.json`

export function getClientVersionHeaders() {
    // 后端可基于这些请求头判断当前管理后台是否低于最低兼容版本。
    return {
        'X-Client-Type': 'qcyy-brand-admin',
        'X-Client-Version': APP_VERSION,
        'X-Client-Commit': APP_COMMIT,
        'X-Client-Api-Compat-Version': API_COMPAT_VERSION,
    }
}
